import React from 'react';

export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1B2C5E]/90 backdrop-blur-2xl border-b border-white/5 shadow-2xl">
      {/* Increased height to accommodate the larger logo */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 md:h-32 flex items-center justify-between">
        <div className="flex items-center group cursor-pointer">
          <img 
            src="https://i.postimg.cc/PJHcFz0Z/Profit-Lense-Ai-removebg-preview.png" 
            alt="ProfitLense.ai" 
            className="h-16 md:h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
          />
        </div>
        
        <div className="flex items-center gap-4 md:gap-8">
          <div className="hidden lg:flex items-center gap-8 mr-4">
            <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Features</a>
            <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Pricing</a>
            <a href="#" className="text-sm font-medium text-text-body hover:text-white transition-colors">Guides</a>
          </div>
          <a 
            href="https://profitlense.ai/contact-us/" 
            className="text-[10px] md:text-sm font-bold text-white bg-[#1E90FF]/10 hover:bg-[#1E90FF]/20 border border-[#1E90FF]/30 px-5 md:px-8 py-2.5 md:py-3 rounded-xl transition-all whitespace-nowrap shadow-lg shadow-[#1E90FF]/5"
          >
            Get Support
          </a>
        </div>
      </div>
    </nav>
  );
}